import React from 'react';
import { InnoModal, InnoModalHeader, InnoModalContent, InnoModalFooter, InnoButton, showModal } from '@innomotics/innomotics-build-react-lib';

interface ShowModalConfig {
    title: string;
    content: string;
    buttonText: string;
    onClose?: () => void;
}

export const showInfoModal = ({ title, content, buttonText, onClose }: ShowModalConfig) => {
    let modalInstance: HTMLInnoModalElement | null = null;

    const handleClose = () => {
        modalInstance?.closeModal(null);
        onClose?.();
    };

    const modalContent = (
        <InnoModal ref={(el: any) => { modalInstance = el; }}>
            <InnoModalHeader showClose={true} onClose={handleClose}>{title}</InnoModalHeader>
            <InnoModalContent>
                <div>
                    <span>{content}</span>
                </div>
            </InnoModalContent>
            <InnoModalFooter>
                <InnoButton onClick={handleClose}>
                    {buttonText}
                </InnoButton>
            </InnoModalFooter>
        </InnoModal>
    );

    showModal({
        size: '720',
        content: modalContent,
        backdrop: true,
        centered: true,
        closeOnEscape: false,
        closeOnBackdropClick: false,
        animation: false
    });
};
